import React from "react";
import moment from "moment";
import { formatWithMinDigits } from "../../../../../../../utility/utils";
import { LAB_PRODUCCION_ESTADOS_DRC } from "../../../../../../../utility/constants";
import { getActionBtn } from "../helpers/actionBtn";
import { BadgeRepetido } from "./BadgeRepetido";

export const SolicitudesTable = ({
    solicitudesPendientes,
    estadoSolicitudes,
    repeticion,
    historial,
}) => {
    let emptyText = "";
    if (estadoSolicitudes === "PENDIENTES") {
        emptyText = "No hay solicitudes pendientes de análisis.";
    } else if (
        estadoSolicitudes === LAB_PRODUCCION_ESTADOS_DRC.PENDIENTE_VALIDAR_DRC
    ) {
        emptyText = "No hay solicitudes análisis de validación.";
    } else if (estadoSolicitudes === "HISTORIAL") {
        emptyText = "No hay registros de historial.";
    }

    return (
        <div className="new-table-wrapper pendientes-analisis__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ID Solicitud</th>
                        <th>Estado</th>
                        <th>Fecha de solicitud</th>
                        <th>Tipo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {solicitudesPendientes.length === 0 && (
                        <tr>
                            <td colSpan={5} className="text-center">
                                {emptyText}
                            </td>
                        </tr>
                    )}
                    {solicitudesPendientes.map((item) => {
                        const estadoClassName =
                            item.estado ===
                                LAB_PRODUCCION_ESTADOS_DRC.DRC_RECHAZADO ||
                            item.estado === LAB_PRODUCCION_ESTADOS_DRC.CANCELADO
                                ? "rojo"
                                : "verde-secundario";

                        const tachadoClassName = item.estado === LAB_PRODUCCION_ESTADOS_DRC.CANCELADO ? "tachado" : "";

                        return (
                            <tr key={item.id} className={tachadoClassName}>
                                <td className="text-center">
                                    {formatWithMinDigits(item.id)}
                                </td>
                                <td className="text-center">
                                    <div className="d-flex justify-content-center align-items-center gap-10">
                                        <span className={estadoClassName}>
                                            {item.estado_display}
                                        </span>
                                        {item.repetido && (
                                            <BadgeRepetido
                                                item={item}
                                                historial={historial}
                                            />
                                        )}
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.fecha_solicitud_analisis
                                        ? moment(
                                              item.fecha_solicitud_analisis,
                                          ).format("DD/MM/YYYY HH:mm")
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.tipo_display}
                                </td>
                                <td>
                                    <div className="table-actions">
                                        {getActionBtn(
                                            estadoSolicitudes,
                                            item,
                                            repeticion,
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
